import { useEffect, useState } from 'react'

import { useNavigation } from '~/context/Navigation'

import Tracking from '~/utils/tracking'

import { ProcessingImageFeedback } from '../../components/ProcessingImageFeedback'

export const ImageInputProcessing = () => {
  const [started, setStarted] = useState(false)
  const [complete, setComplete] = useState(false)
  const [success, setSuccess] = useState(false)

  const { navigate } = useNavigation()

  useEffect(() => {
    const timers = [
      setTimeout(() => setStarted(true), 250),
      setTimeout(() => setComplete(true), 1000),
      setTimeout(() => setSuccess(true), 1500),
      setTimeout(() => {
        Tracking.logEvent('CAMERA_UPLOAD', { widget: true })
        navigate('InformData', { origin: 'ImageInputProcessing' })
      }, 1750),
    ]

    return () => {
      timers.forEach(clearTimeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <ProcessingImageFeedback started={started} complete={complete} success={success} />
}
